/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Enum for ITKCOR ClientAuthenticationType.
 */
export enum ClientAuthenticationType {
    /**
     * // Regular Microsoft username and password used to signin
     */
    PublicClient = 0,
    /**
     * ClientId and Secret or Cerficate used
     */
    ConfidentialClient = 1,
}
